"use strict";

/* Variables */

const MAX_AMOUNT = 5;

const ROLL_TYPE_ROLLS = 28;
const ROLL_TYPE_HOT = 29;
const ROLL_TYPE_BAKED = 61;
const ROLL_TYPE_ADD = 71;

const ROLL_ITEM = 'roll-item-';
const ROUBLE = '<span class="rouble">₽</span>';


/* Constructors */

class Roll {

  /**
   * Ролл.
   * @param id
   */
  constructor(id) {
    let obj = JSON.parse(document.getElementById(ROLL_ITEM+id).getAttribute('data-object')); // установка json в data-object

    this.id = +id;
    this.title = obj.title;
    this.description = obj.description;
    this.weight = +obj.weight;
    this.price = +obj.commerce_price / 100;
    this.imageSrc = obj.field_image.src;
    this.imageAlt = obj.field_image.alt;
    this.ingredients = obj.ingredients;

    this.amount = +(document.getElementById(ROLL_ITEM+id).getAttribute('data-amount'));
    this.type = +(document.getElementById(ROLL_ITEM+id).getAttribute('data-type'));
    this.total = this.price;
  }

  /**
   * Установка количества в data-атрибут.
   */
  setAmount() {
    document.getElementById(ROLL_ITEM+this.id).setAttribute('data-amount', this.amount);
    this.countTotal();
  }

  /**
   * Активация ролла (установка класса .active.
   */
  activate() {
    document.getElementById(ROLL_ITEM+this.id).classList.add('active');
  }

  /**
   * Деактивация ролла (удаление класса .active.
   */
  deactivate() {
    document.getElementById(ROLL_ITEM+this.id).classList.remove('active');
  }

  /**
   * Увеличение количества.
   */
  increaseAmount() {
    if (this.amount >= MAX_AMOUNT) {
      this.resetAmount();
      return;
    }
    this.amount++;
    this.setAmount();
    this.activate();
  }

  /**
   * Уменьшение количества.
   */
  decreaseAmount() {
    this.amount--;
    this.setAmount();
  }

  /**
   * Обнуление (сброс) количества.
   */
  resetAmount() {
    this.amount = 0;
    this.setAmount();
    this.deactivate();
  }

  /**
   * Расчет стоимости роллов.
   */
  countTotal() {
    this.total = this.price * this.amount;
  }

}



class RollSet {

  /**
   * Сет роллов.
   */
  constructor() {
    this.weight = 0;
    this.amount = 0;
    this.percent = 0;
    this.discount = 0;
    this.total = 0;
    this.totalAdd = 0;
    this.rolls = [];
    this.beautify = !!(document.getElementsByName('beautify')[0].checked);
  }

  /**
   * Только роллы, только хардкор!
   * @param roll
   * @returns {boolean}
   */
  static isRoll(roll) {
    return (roll.type === ROLL_TYPE_ROLLS || roll.type === ROLL_TYPE_HOT || roll.type === ROLL_TYPE_BAKED);
  };

  /**
   * Обработка сета.
   */
  processing() {
    this.getWeight();
    this.getAmount();
    this.getTotal();
    this.getTotalAdd();
    this.countDiscount();
    this.setInfo();
  }

  /**
   * Подсчет общего веса сета.
   * @returns {number}
   */
  getWeight(totalWeight = 0) {
    this.rolls.forEach(function (roll) {
      if (RollSet.isRoll(roll)) {
        totalWeight += roll.weight * roll.amount;
      }
    });
    this.weight = totalWeight;
    return totalWeight;
  };

  /**
   * Подсчет общего количества роллов в сете.
   * @returns {number}
   */
  getAmount(totalAmount = 0) {
    this.rolls.forEach(function (roll) {
      if (RollSet.isRoll(roll)) {
        totalAmount += roll.amount;
      }
    });
    this.amount = totalAmount;
    return totalAmount;
  };

  /**
   * Посчет общей стоимости сета.
   * @returns {number}
   */
  getTotal(totalTotal = 0) {
    this.rolls.forEach(function (roll) {
      if (RollSet.isRoll(roll)) {
        totalTotal += roll.total;
      }
    });
    this.total = totalTotal;
    return totalTotal;
  }

  /**
   * Посчет общей стоимости соусов, имбиря и вассаби.
   * @param totalTotalAdd
   * @returns {number}
   */
  getTotalAdd(totalTotalAdd = 0) {
    this.rolls.forEach(function (roll) {
      if (roll.type === ROLL_TYPE_ADD) {
        totalTotalAdd += roll.total;
      }
    });
    this.totalAdd = totalTotalAdd;
    return totalTotalAdd;
  }

  /**
   * Добавление ролла в сет.
   * @param item
   */
  pushRoll(item) {
    item.increaseAmount();
    if (item.amount === 0) {
      delete this.rolls[item.id];
      this.processing();
      return;
    }
    this.rolls[item.id] = item;
    this.processing();
  };

  /**
   * Удаление ролла из сета.
   * @param item
   */
  removeRoll(item) {
    item.resetAmount();
    delete this.rolls[item.id]; //this.rolls.splice(item.id, 1); - работает, но сдвигает индексы
    this.processing();
  }

  /**
   * Сделать красиво вкл/выкл.
   */
  beautifyToggle() {
    this.beautify = this.beautify === false;
  }

  /**
   * Расчет скидки на роллы в сете.
   */
  countDiscount() {
    if (this.amount === 2) {
      this.discount = Math.floor(this.total * 0.05);
      this.percent = 5;
    } else if (this.amount === 3) {
      this.discount = Math.floor(this.total * 0.10);
      this.percent = 10;
    } else if (this.amount === 4) {
      this.discount = Math.floor(this.total * 0.15);
      this.percent = 15;
    } else if (this.amount >= 5) {
      this.discount = Math.floor(this.total * 0.20);
      this.percent = 20;
    } else {
      this.discount = 0;
      this.percent = 0;
    }
  }

  /**
   * Вставка информации в HTML.
   */
  setInfo() {
    (this.amount > 0) ? document.getElementById('rolls-info').classList.add('active') : document.getElementById('rolls-info').classList.remove('active');
    (this.amount > 0) ? document.getElementById('rolls-preamble').classList.add('active') : document.getElementById('rolls-preamble').classList.remove('active');

    document.getElementById('rolls-info-amount').innerHTML = this.amount;
    document.getElementById('rolls-info-weight').innerHTML = `${this.weight}&nbsp;г`;
    document.getElementById('rolls-info-price').innerHTML = `${this.total}${ROUBLE}`;
    document.getElementById('discount-percent').innerHTML = `${this.percent}%`;
    document.getElementById('discount-value').innerHTML = `${this.discount}${ROUBLE}`;
    document.getElementById('add-value').innerHTML = `${this.totalAdd}${ROUBLE}`;
    document.getElementById('rolls-total').innerHTML = `${this.total + this.totalAdd - this.discount}${ROUBLE}`;
  }

}


// Инициализация сета роллов.
let set = new RollSet;
